import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

type RoleRouteProps = {
  allowedRoles?: string[]; // if omitted -> only requires auth
};

const RoleRoute: React.FC<RoleRouteProps> = ({ allowedRoles }) => {
  const { isAuthenticated, loading, user } = useAuth();

  if (loading) return <div>Loading...</div>;

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // If no allowedRoles provided, any authenticated user can access
  if (!allowedRoles || allowedRoles.length === 0) {
    return <Outlet />;
  }

  const userRole = user?.role ?? "";

  // Allow when user's role matches one of allowedRoles
  if (allowedRoles.includes(userRole)) {
    return <Outlet />;
  }

  // You can replace this with a "Not Authorized" page or toast
  return <Navigate to="/profile" replace />;
};

export default RoleRoute;
